import { store, getElement } from '@wordpress/interactivity';

// Register a block action using the store
store( 'webx-blocks/reset-filter', {
    actions: {
        *reset( event ) {
            const { ref } = getElement();
            const queryRef = ref.closest(
                '.wp-block-query[data-wp-router-region]'
            );

            // get current query args from URL
            const url = new URL( window.location.href );
            // remove query args
            const paramsToDelete = Array.from( url.searchParams.keys() ).filter(
                ( key ) =>
                    [ 'query-', 'filter-', 'search-' ].some( ( prefix ) =>
                        key.startsWith( prefix )
                    )
            );
            paramsToDelete.forEach( ( key ) => url.searchParams.delete( key ) );

            event.preventDefault();

            const { actions } = yield import(
                '@wordpress/interactivity-router'
            );
            yield actions.navigate( url.href );
        },
    },
} );
